/* tslint:disable */
/* eslint-disable */
/**
 * Linked Events information API
 * Linked Events provides categorized data on events and places using JSON-LD format. Events can be searched by date and location. Location can be exact address or larger area such as neighbourhood or borough JSON-LD format is streamlined using include mechanism. API users can request that certain fields are included directly into the result, instead of being hyperlinks to objects. Several fields are multilingual. These are implemented as object with each language variant as property. In this specification each multilingual field has (fi,sv,en) property triplet as example.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    InlineResponse200,
    InlineResponse200FromJSON,
    InlineResponse200ToJSON,
} from '../models';

export interface EventSearchRequest {
    page?: number;
    pageSize?: number;
    type?: string;
    q?: string;
    input?: string;
    start?: Date;
    end?: Date;
}

/**
 * 
 */
export class SearchApi extends runtime.BaseAPI {

    /**
     * <h2 id=\"using-search-endpoint\">Using the search endpoint</h2> <p>This is the supposedly intelligent Elasticsearch Finnish full-text search for both events and places.     The results are sorted by relevance score shown in the <code>score</code> field. The search parameter is <code>?q=</code>. <h4 id=\"specifying-resource-type\">Specifying resource type</h4> <p>In the default case, both events and places are returned. The type of each resource is returned in the     <code>resource_type</code> field. You may use the parameter <code>type</code> to ask for only <code>event</code> or <code>place</code>. <h4 id=\"events-with-decay-score\">Future events with time decay</h4> <p>When searching for events only (<code>?type=event</code>), by default only future events are returned, with a decay function applied so that next     events get a higher relevance score. This means that     events in the near future are returned first:</p> <pre><code>search/?type=event&q=sibelius </code></pre> <p><a href=\"?type=event&q=sibelius\" title=\"json\">See the result</a></p> <h4 id=\"events-with-time-filtering\">Events with time filtering</h4> <p>When searching for events only (<code>?type=event</code>), you may also search for events in the specified time range using     <code>start</code> or <code>end</code> or both. In this case, relevance score is calculated only based on Finnish tokenization of the search string, with no time preference:</p> <pre><code>search/?type=event&q=sibelius&start=2017-01-01 </code></pre> <p><a href=\"?type=event&q=sibelius&start=2017-01-01\" title=\"json\">See the result</a></p> <h4 id=\"autocomplete\">Autocomplete</h4>         <p>For fast autocomplete substring match in the resource name, use the <code>?input=</code> parameter instead.             When searching for events only (<code>?type=event</code>), by default only future events are returned, with a decay function applied so that next     events get a higher relevance score. May be combined with <code>start</code> and <code>end</code>. <pre><code>search/?type=place&input=sibe </code></pre> <p><a href=\"?type=event&input=sibe\" title=\"json\">See the result</a></p> 
     * Search through events and places
     */
    async eventSearchRaw(requestParameters: EventSearchRequest): Promise<runtime.ApiResponse<InlineResponse200>> {
        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }

        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }

        if (requestParameters.q !== undefined) {
            queryParameters['q'] = requestParameters.q;
        }

        if (requestParameters.input !== undefined) {
            queryParameters['input'] = requestParameters.input;
        }

        if (requestParameters.start !== undefined) {
            queryParameters['start'] = (requestParameters.start as any).toISOString();
        }

        if (requestParameters.end !== undefined) {
            queryParameters['end'] = (requestParameters.end as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/search/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => InlineResponse200FromJSON(jsonValue));
    }

    /**
     * <h2 id=\"using-search-endpoint\">Using the search endpoint</h2> <p>This is the supposedly intelligent Elasticsearch Finnish full-text search for both events and places.     The results are sorted by relevance score shown in the <code>score</code> field. The search parameter is <code>?q=</code>. <h4 id=\"specifying-resource-type\">Specifying resource type</h4> <p>In the default case, both events and places are returned. The type of each resource is returned in the     <code>resource_type</code> field. You may use the parameter <code>type</code> to ask for only <code>event</code> or <code>place</code>. <h4 id=\"events-with-decay-score\">Future events with time decay</h4> <p>When searching for events only (<code>?type=event</code>), by default only future events are returned, with a decay function applied so that next     events get a higher relevance score. This means that     events in the near future are returned first:</p> <pre><code>search/?type=event&q=sibelius </code></pre> <p><a href=\"?type=event&q=sibelius\" title=\"json\">See the result</a></p> <h4 id=\"events-with-time-filtering\">Events with time filtering</h4> <p>When searching for events only (<code>?type=event</code>), you may also search for events in the specified time range using     <code>start</code> or <code>end</code> or both. In this case, relevance score is calculated only based on Finnish tokenization of the search string, with no time preference:</p> <pre><code>search/?type=event&q=sibelius&start=2017-01-01 </code></pre> <p><a href=\"?type=event&q=sibelius&start=2017-01-01\" title=\"json\">See the result</a></p> <h4 id=\"autocomplete\">Autocomplete</h4>         <p>For fast autocomplete substring match in the resource name, use the <code>?input=</code> parameter instead.             When searching for events only (<code>?type=event</code>), by default only future events are returned, with a decay function applied so that next     events get a higher relevance score. May be combined with <code>start</code> and <code>end</code>. <pre><code>search/?type=place&input=sibe </code></pre> <p><a href=\"?type=event&input=sibe\" title=\"json\">See the result</a></p> 
     * Search through events and places
     */
    async eventSearch(requestParameters: EventSearchRequest): Promise<InlineResponse200> {
        const response = await this.eventSearchRaw(requestParameters);
        return await response.value();
    }

}
